module.exports = __webpack_public_path__ + "pnskfsquadron/img/en-slider-1.jpg?32bdcdeb";